<!-- 解决方案 -->
<template>
  <div class="academy-basePanel-container">
    <div class="academy-basePanel-wrapper">
      <header
        class="academy-basePanel-hd"
        v-scroll-animate="{ animation: 'fadeInUp' }"
      >
        <h2 class="academy-basePanel-title">
          {{ baseInfo[type].title }}
        </h2>
        <h3 class="academy-basePanel-subTitle">
          <span class="strong">{{ type }}</span>
          {{ baseInfo[type].subTitle }}
        </h3>
        <div class="academy-basePanel-desc">
          <div
            v-for="(item, index) in baseInfo[type].desc"
            :key="'academy_desc_' + index"
          >
            {{ item }}
          </div>
        </div>
        <div class="academy-basePanel-btn">
          <el-button
            class="academy-btn"
            @click="toHelp(helpDocumentUrl)"
            style="margin-right: 20px"
          >
            <i class="el-icon-tickets"></i> 查看帮助文档
          </el-button>
          <!-- 下载按钮 -->
          <template v-if="btnList.length > 0">
            <DownLoad
              v-for="item in btnList"
              :key="item.btnId"
              :btnLabel="item.btnName"
              :fileUrl="item.filePath"
              :fileName="item.fileTitle"
              style="margin-right: 20px"
            />
          </template>
        </div>
      </header>
      <!-- 视频 -->
      <article class="academy-basePanel-bd">
        <header
          class="basePanel-video-hd academy-basePanel-subTitle"
          v-scroll-animate="{ animation: 'fadeInUp' }"
        >
          <span class="aside">
            <span class="strong">{{ type }}</span>
            教学视频！
          </span>
          <el-button
            v-if="videoList.length > 0"
            class="academy-btn"
            @click="toVideo(type)"
          >
            更多教学视频
          </el-button>
        </header>
        <EmptyPage v-if="videoList.length == 0" :name="'暂无数据!'" />
        <template v-else>
          <el-row
            :gutter="30"
            class="basePanel-video-bd"
            v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
          >
            <el-col :span="8" v-for="video in videoList" :key="video.id">
              <div class="card">
                <img
                  class="video-cover"
                  :src="video.cover"
                  alt=""
                  @click="playVideo(video)"
                />
                <el-tooltip :content="video.title" placement="top-start">
                  <h4 class="video-title" @click="playVideo(video)">
                    {{ video.title }}
                  </h4>
                </el-tooltip>
                <h5 class="video-desc">{{ video.desc }}</h5>
                <!-- <div class="academy-play flex" @click="playVideo(video)">
                  <img src="@/assets/images/icon-play.svg" alt="" srcset="" />
                  <div class="academy-text">查看教学视频</div>
                </div> -->
              </div>
            </el-col>
          </el-row>
        </template>
      </article>
      <!-- 技巧 -->
      <article class="academy-basePanel-bd" style="margin-top: 40px">
        <header
          class="basePanel-video-hd academy-basePanel-subTitle"
          v-scroll-animate="{ animation: 'fadeInUp' }"
        >
          <span class="aside">
            <span class="strong">{{ type }}</span>
            进阶技巧！
          </span>
          <el-button
            v-if="skillList.length > 0"
            class="academy-btn"
            @click="toTechniques(type)"
          >
            更多进阶技巧
          </el-button>
        </header>
        <EmptyPage v-if="skillList.length == 0" :name="'暂无数据!'" />
        <template v-else>
          <el-row
            :gutter="30"
            class="basePanel-video-bd"
            v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
          >
            <el-col :span="8" v-for="item in skillList" :key="item.id">
              <div class="card">
                <img class="video-cover" :src="item.coverUrl" alt="" />
                <el-tooltip :content="item.title" placement="top-start">
                  <h4 class="video-title">{{ item.title }}</h4>
                </el-tooltip>
                <!-- <h5 class="video-desc">{{ item.subtitle }}</h5> -->
                <div
                  class="academy-play flex"
                  @click="viewAdvancedTechniques(item)"
                >
                  <img src="@/assets/images/icon-book.svg" alt="" srcset="" />
                  <div class="academy-text">查看进阶技巧</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </template>
      </article>
      <VideoModal
        :dialogVisible.sync="dialogVisible"
        :video="video"
      ></VideoModal>
    </div>
  </div>
</template>

<script>
import DownLoad from "@/components/DownLoad";
import VideoModal from "@/components/videoModal.vue";
import EmptyPage from "@/components/EmptyPage.vue";
import { tracklogApi } from "@/api/website";
export default {
  name: "BaseAcademy",
  components: { DownLoad, VideoModal, EmptyPage },
  props: {
    type: {
      type: String,
      default: "AIRoad",
    },
    helpDocumentUrl: {
      type: String,
      default: "",
    },
    freeTrialUrl: {
      type: String,
      default: "",
    },
    freeTrialName: {
      type: String,
      default: "",
    },
    videoList: {
      type: Array,
      default: () => [],
    },
    skillList: {
      type: Array,
      default: () => [],
    },
    btnList: {
      type: Array,
      default: () => [],
    },
    categoryId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      baseInfo: {
        AIRoad: {
          title: "快速掌握AIRoad，从这里开始",
          subTitle: "帮助文档！",
          desc: [
            "AIRoad依托自主研发的BIM引擎，基于GIS、航测遥感等数据构建数字化地形，快速实现方案参数化和智能化设计。通过动态交互式布线，自动构建方案模型。持续挖掘AI大语言模型和内容生成技术，在创意方案、效果表达和辅助成图等应用场景，提升设计效率。能够提升方案设计效率8～10倍，提升方案设计综合效率20～30%。",
          ],
        },
        EICAD: {
          title: "快速掌握EICAD，从这里开始",
          subTitle: "帮助文档！",
          desc: [
            "EICAD经过多年的发展，目前已覆盖公路、市政及轨道交通领域，是一款含有外业调查、数字地面模型、路线、互通立交、路基路面、桥涵、隧道、交通工程、给排水等多个专业模块的数字化设计软件全家桶。EICAD设计软件始终坚持“提升设计效率和设计品质”这一理念，持续创新，不断丰富产品功能，为客户创造价值，为基础设施建设提供优质的数字化软件产品。",
          ],
        },
        VRRoad: {
          title: "快速掌握VRRoad，从这里开始",
          subTitle: "帮助文档！",
          desc: [
            "道路驾驶模拟与安全评价系统VRRoad，是面向道路几何设计及安全性评价的软、硬件集成解决方案。系统可快速导入设计成果，并参照OpenDrive标准生成精确描述车道及道路沿线特征的模拟路网，实现信息完备的实验数据同步采集，支持多自由度运动平台驱动，提供逼真的驾驶体感。",
          ],
        },
        Report3D: {
          title: "快速掌握Report3D，从这里开始",
          subTitle: "帮助文档！",
          desc: [
            "Report3D数字化汇报系统，是一款基于游戏引擎研发的、面向多类型工程的汇报工具，实现实时渲染的高效场景创造、PPT的复杂制作功能，使用户能够实时查看和操作数字孪生模型。不需要复杂的安装或配置，降低三维场景使用门槛，让更多的人能够轻松参与三维场景搭建与PPT汇报。",
            "系统以一种三维的、动态的、可交互的汇报方式，探索数字时代成果展示的新模式，以微电影的形式去讲述项目，打造沉浸式体验场景。",
          ],
        },
      },
      dialogVisible: false,
      video: undefined,
    };
  },
  computed: {},

  created() {},
  mounted() {},
  methods: {
    toHelp(url) {
      if (url && url.includes("helpDocuments")) {
        this.$uniFun.openUrl(`${url}`);
      } else {
        this.$uniFun.openInCurrentTab("/download?anchor=manual");
      }
    },
    // toSoftware() {
    //   this.$uniFun.openInCurrentTab("/download?anchor=software");
    // },
    /**
     * 教学视频
     * **/
    // 视频列表页
    toVideo(type) {
      this.$uniFun.openInCurrentTab(
        `/academy/moreVideoList?anchor=${type}&&categoryId=${this.categoryId}`,
      );
    },
    // 播放视频
    playVideo(video) {
      tracklogApi({ module: "4_" + video.id });
      let videoFormat = [".mp4", ".webm", "ogg", ".MP4"];
      // 判断地址是页面还是视频
      const url = new URL(video.videoUrl);
      const pathname = url.pathname;
      const isSupportedFormat = videoFormat.some((format) =>
        pathname.endsWith(format),
      );
      if (isSupportedFormat) {
        // 符合格式的视频，弹窗展示
        this.dialogVisible = true;
        this.video = video;
      } else {
        // 不符合的，跳转标签页
        window.open(video.videoUrl, "_blank");
      }
    },
    /**
     * 进阶技巧
     * **/
    // 跳转列表页
    toTechniques(type) {
      this.$uniFun.openInCurrentTab(
        `/academy/advancedTechniques?anchor=${type}&&categoryId=${this.categoryId}`,
      );
    },
    // 查看详情
    viewAdvancedTechniques(item) {
      this.$uniFun.openInCurrentTab(
        `/academy/articleDetail?&id=${item.id}&anchor=${this.type}`,
      );
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/common.scss";
.academy-basePanel-container {
  background: #fff;
  .academy-basePanel-wrapper {
    width: 1049px;
    margin: 0 auto;
    padding: 40px 0;
    border-bottom: 1px solid #d8d8d8;
  }
  .academy-basePanel-subTitle {
    margin-bottom: 12px;
    font-family: Arial, Arial;
    font-size: 24px;
    color: #000000;
    line-height: 24px;
    text-align: left;
    font-weight: 400;
    .strong {
      padding-right: 4px;
      font-weight: 600;
    }
  }
  .academy-basePanel-hd {
    margin-bottom: 40px;
    .academy-basePanel-title {
      margin-bottom: 40px;
      font-weight: 600;
      font-size: 24px;
      color: #000000;
      line-height: 24px;
      text-align: left;
    }

    .academy-basePanel-desc {
      margin-bottom: 16px;
      font-weight: 400;
      font-size: 14px;
      color: #1d1d1f;
      line-height: 32px;
      text-align: justify;
      text-indent: 2em;
    }
  }

  .academy-btn {
    padding: 8px 24px;
    border-color: #333333;
    border: 1px solid #333333;
    color: #333333;
    font-size: 14px;
    &:hover {
      background: transparent;
      border-color: #0035fb;
      color: #0035fb;
    }
  }
  .academy-play {
    cursor: pointer;
    &:hover {
      color: #0035fb;
    }
  }
  .academy-text {
    // padding: 8px 0;
    font-size: 14px;
    line-height: 16px;
    color: #333333;
    margin-left: 8px;
    &:hover {
      color: #0035fb;
    }
  }

  .academy-basePanel-bd {
    font-weight: 400;
    font-size: 18px;
    color: #333;
    line-height: 40px;
    text-align: justify;
    font-style: normal;
  }
  .basePanel-video-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
  }
  .basePanel-video-bd {
    .card {
      width: 320px;
      box-sizing: border-box;
      padding-bottom: 24px;
    }
    .video-title {
      height: 48px;
      margin-bottom: 16px;
      font-weight: 600;
      font-size: 18px;
      color: #000000;
      line-height: 24px;
      text-align: justify;
      font-style: normal;
      @extend .text-truncate-multiline;
      --line-clamp: 2;
      cursor: pointer;
    }
    .video-desc {
      height: 48px;
      margin-bottom: 16px;
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      line-height: 24px;
      text-align: justify;
      font-style: normal;
      @extend .text-truncate-multiline;
      --line-clamp: 2;
    }
    .video-cover {
      width: 100%;
      height: 180px;
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        transform: scale(1.05);
      }
    }
  }
}
</style>
<style lang="scss">
.academy-basePanel-container {
  .empty_page .empty {
    margin-top: 0 !important;
    padding-bottom: 0 !important;
  }
}
</style>
